export const assistantSize = {
  width: 192,
  height: 192,
};

export const bedrockResultNotFoundReply =
  'The model cannot find sufficient information';

// TODO: refactor as props
// the following flags are for debug purproses
export const enableDebugMode = false;
export const enableDebugControls = false;
export const enableLogging = true;
// display mute button only on hover over assistant
export const showMuteButtonOnHover = false;
export const useAudioZoneBasedContext = true;
export const debugEventId = undefined; //'a0f591ff-faf3-4beb-b3b0-621a3fc8faff';
export const debugTagName = undefined;
